import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { StylesProvider, padding } from '@rexlabs/styling';
var TOKENS = {
  button: _objectSpread(_objectSpread({}, padding.tokens({
    target: 'button.icon',
    all: 'xs'
  })), {}, {
    // Square unless the icon content is too wide for some reason
    height: function height(_ref) {
      var token = _ref.token;
      return token('button.icon.height', '4rem');
    },
    minWidth: function minWidth(_ref2) {
      var token = _ref2.token;
      return token('button.icon.minWidth', '4rem');
    },
    compact: _objectSpread(_objectSpread({}, padding.tokens({
      target: 'button.icon.compact',
      all: function all() {
        return '0.1rem';
      }
    })), {}, {
      minWidth: function minWidth(_ref3) {
        var token = _ref3.token;
        return token('button.icon.compact.minWidth', '2rem');
      }
    })
  })
};
export var IconButton = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var Button = _ref4.Button,
      Icon = _ref4.Icon,
      props = _objectWithoutProperties(_ref4, ["Button", "Icon"]);

  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: TOKENS
  }, /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Icon, null)));
});
export default IconButton;